// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__YPgIc","icon":"SortAdornment_icon__2lS25","up":"SortAdornment_up__3nihL","down":"SortAdornment_down__3rM0s","active":"SortAdornment_active__2fHuu"};